import React from 'react'

import AvailableCoupon from './AvailableCoupon/AvailableCoupon';
import CouponsAPI from "../../../../apis/CouponsAPI";
import PropTypes from "prop-types";
import { ADD_COUPON, getCart, REMOVE_COUPON } from '../../../../stores/CartStateStore';
//import I18n from 'i18n';

export default class CouponForm extends React.Component {

    static contextTypes = {
        userAuthToken: PropTypes.string
    };

    constructor(props) {
        super(props);

        let error_messages = [];
        if (props.initialErrors && props.initialErrors.coupon_code) {
            error_messages = props.initialErrors.coupon_code.map(function (error) {
                return error;
            });
        }

        this.state = {
            coupon_message: null,
            error_messages: error_messages,
            coupon_code: ''
        };

        CouponsAPI.SetUserAuthToken(props.userAuthToken)
    }

    /*componentDidMount() {
        const coupons = CartStore.getCoupons();
        const coupon_codes = Object.keys(coupons);
        const coupon_code = coupon_codes.length > 0 ? coupon_codes[0] : null;

        if (coupon_code) {
            this.setState({coupon_code: coupon_code});
            this.validateCoupon();
        }
    }*/

    componentDidUpdate(prevProps, prevState) {
        const { coupon_code } = this.state;

        if (coupon_code && (coupon_code.length > 0) && this.props.startTime !== prevProps.startTime) {
            this.startCouponVerification();
        }
    }

    validateCoupon = () => {
        const code = this.state.coupon_code;
        const amount = getCart(this.props.cartState).total || 0
        const { venueId, startTime } = this.props;

        if (!code || code.length === 0) { return; }

        CouponsAPI.CheckCoupon(code, amount, venueId, startTime).then((coupon) => {
            let coupon_message = coupon.message;

            if (!coupon_message) {
                switch (coupon.discount_type) {
                    case 'discount_amount':
                        coupon_message = I18n.t('pages.orders.new.coupon_messages.discount_value', {value: coupon.humanized_discount_value});
                        break;
                    case 'points':
                        coupon_message = I18n.t('pages.orders.new.coupon_messages.points', {value: coupon.discount_value});
                        break;
                    default:
                        coupon_message = I18n.t('pages.orders.new.coupon_messages.default');
                }
            }

            this.setState({coupon_message: coupon_message});

            this.props.dispatchCartState({type: ADD_COUPON, payload: {code: coupon.code, amount: coupon.discount_value} })

        }).catch((err) => {

            this.props.dispatchCartState({type: REMOVE_COUPON, payload: {code: code} })

            if (err.status === 422) {
                const message = err.response.body.full_error_messages || "Impossibile usare questo coupon";

                this.setState({error_messages: message });
                return;
            }
            if (err.status === 404) {
                this.setState({error_messages: [I18n.t('pages.orders.new.coupon_not_found')]});
            }
        });
    }

    startCouponVerification = (event) => {
        if (event) { event.preventDefault(); }
        //var value = event.target.value;

        // if i have already inserted a coupon it stays that way until it will be deleted
        //var coupons = CartStore.getCoupons();
        //if(Object.keys(coupons).length > 0){return}

        this.setState({coupon_message: null, error_messages: []});

        // validate coupon only if more than 5 digits
        //if(value.length < 5){return}
        this.validateCoupon();
    };

    handleRemoveCoupon = () => {
        this.props.dispatchCartState({type: REMOVE_COUPON, payload: {code: this.state.coupon_code} })
        this.setState({coupon_message: null, error_messages: [], coupon_code: ''});
    };

    handleChooseCouponFromList = (code) => {
        this.setState({ coupon_code: code });

        //TODO: Remove the timeout and change this
        setTimeout( this.startCouponVerification, 500);
    };

    isVerifyButtonDisabled = () => {
        const minValidLength = 3;
        return ((typeof this.state.coupon_code !== "string") || (this.state.coupon_code.length < minValidLength));
    };

    handleOnCodeChange = (event) => {
        const value = event.target.value || '';

        if (value === '') {
            this.handleRemoveCoupon();
        } else {
            this.setState({coupon_code: value});
        }
    };

    renderCouponInput() {

        const coupon_summary = (
            <div>
                <p>
                    {I18n.t('pages.orders.new.selected_coupon', {code: this.state.coupon_code})}
                    <span className="fal fa-trash pull-right" onClick={this.handleRemoveCoupon}/>
                </p>
            </div>
        );

        const coupon_form = (
            <div className="input-group">
                <input type="text" name="coupon_code" className="form-control" value={this.state.coupon_code}
                       onChange={this.handleOnCodeChange}/>
                <span className="input-group-btn">
                    <button className="btn btn-blue" style={{lineHeight: '36px'}} type="button"
                            disabled={this.isVerifyButtonDisabled()}
                            onClick={this.startCouponVerification}>{I18n.t('verify')}</button>
                </span>
            </div>
        );

        return this.state.coupon_message ? coupon_summary : coupon_form;
    }

    renderAvailableCoupons(coupons) {
        return (
                <div>
                    <label style={styles.yourCouponTitle}>{I18n.t('pages.orders.new.your_coupons')}</label>
                    {

                        coupons.map((coupon) => {
                            return <AvailableCoupon {...coupon}
                                                    key={coupon.code}
                                                    onClick={() => this.handleChooseCouponFromList(coupon.code) }
                            />
                        })
                    }
                </div>
        );
    }

    renderErrors() {
        const errors_html = (
            <div className="help-block error">
                <ul>
                    {this.state.error_messages.map(function (error, i) {
                        return <li key={i}>{error}</li>
                    })}
                </ul>
            </div>
        );

        return (this.state.error_messages.length > 0) ? errors_html : null
    }

    render() {
        const coupons = this.props.availableCoupons;

        let form = (
            <div>
                {this.renderCouponInput()}
                {this.renderErrors()}
                {coupons && (coupons.length > 0) && !this.state.coupon_message && this.renderAvailableCoupons(coupons)}
                {this.state.coupon_message ?
                    <div className="alert alert-success">{this.state.coupon_message}</div> : null }
            </div>
        );

        if (!this.props.acceptsCoupons) {
            form = <p> {I18n.t('pages.orders.new.coupon_messages.venue_disabled')}. </p>
        }

        return (
            <div>
                <fieldset>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="coupon_code"
                                       className="control-label">{I18n.t('cart_summary.promo_code')}</label>
                                {form}
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        );
    }
}

const styles = {
    yourCouponTitle: {
        margin: '20px 0 10px 0',
    }
};
